import { FC } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { FormCheckboxList } from '../../../../../../shared/components/form';
import { ArticleListsTabDataRes } from '../../../../services/article.service';
import { listsTabState } from '../lists.state';
import { IconButton, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GotoSettingsIcon } from '../../../../../../svg/custom.svg.tsx';

export const ListsForm: FC<IListsForm> = ({ formMethods }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    formState: { isDirty },
  } = formMethods;

  const onSubmit = () => {
    if (isDirty) listsTabState.pub.save();
  };

  return (
    <FormProvider {...formMethods}>
      <SForm noValidate onBlur={onSubmit}>
        <FormCheckboxList
          withDivider
          emptyListIndication={{
            title: t('common.list_are_not_configured'),
            text: (
              <Trans
                style={{ display: 'flex' }}
                i18nKey='common.click_button_above_to_configure'
                components={{ icon: <SSettingsIcon /> }}
              />
            ),
          }}
          headerRightOptions={
            <IconButton
              sx={{ ml: 'auto', height: '40px' }}
              onClick={() => navigate('/settings/configuration/article')}
              title={t('common.settings')}
            >
              <GotoSettingsIcon />
            </IconButton>
          }
          name='articleListsCheckedState'
          controlLabel={'<' + t('common.all_lists') + '>'}
        />
      </SForm>
    </FormProvider>
  );
};
interface IListsForm {
  formMethods: UseFormReturn<ArticleListsTabDataRes>;
}

const SForm = styled('form')({
  height: '100%',
});

export const SSettingsIcon = styled(GotoSettingsIcon)(({ theme }) => ({
  marginRight: 2,
  marginLeft: 2,
  height: '24px !important',
  width: '24px !important',
  verticalAlign: 'bottom',
  color: `${theme.palette.text.secondary}!important`,
}));
